import store from './store';
const Router = window['VueRouter'] || require('vue-router').default;
import SPCoreBrandSummary from './views/spcore/SPCoreBrandSummary';
import SPCoreFrmSummary from './views/spcore/SPCoreFrmSummary';
import SPCorePatientSummary from './views/spcore/SPCorePatientSummary';
import SPCorePatientList from './views/spcore/SPCorePatientList';
import SPCorePatient from './views/spcore/SPCorePatient';
import SPCoreProviderList from './views/spcore/SPCoreProviderList';
import SPCoreProvider from './views/spcore/SPCoreProvider';
import SPCoreProductMovement from './views/spcore/SPCoreProductMovement';
import SPCorePharmacyNetwork from './views/spcore/SPCorePharmacyNetwork';
import SPCoreDataEnablement from './views/spcore/SPCoreDataEnablement';
import SPCoreRequestDemo from './views/spcore/SPCoreRequestDemo';
import ScipherRequestDemo from './views/spcore/ScipherRequestDemo';
import Cohorts from './views/analytics/cohorts/Cohorts.vue';
import Cohort from './views/analytics/cohorts/Cohort.vue';
import MedInsights from './views/tableau/medInsights/MedInsights.vue';
import HCPProfiles from './views/hcpProfiles/HCPProfiles.vue';
import BrandDashboard from './views/brandDashboard/AggregatedDashboard.vue';

import EnterpriseMetrics from './views/tableau/enterpriseMetrics/EnterpriseMetrics.vue';
import ITOperations from './views/tableau/itOperations/ITOperations.vue';
import CallPlanning from './views/callPlanning/CallPlanning.vue';
import CallPlanningUser from './views/callPlanning/CallPlanningUser.vue';
import CallPlanningManager from './views/callPlanning/CallPlanningManager.vue';
import CallPlanningManagerUsers from './views/callPlanning/CallPlanningManagerUsers.vue'
import CallPlanningAdmin from './views/callPlanning/CallPlanningAdmin.vue';
import CallPlanningAdminUser from './views/callPlanning/CallPlanningAdminUser.vue';
import DownloadResults from './views/analytics/runs/DownloadResults.vue';
import AllApplicationUsers from './views/admins/AllApplicationUsers.vue';
import SQLGenerator from './views/sqlGenerator/SQLGenerator.vue';
import ITMOrders from './views/itm/ITMOrders.vue';
import ITMProducts from './views/itm/ITMProducts.vue';
import ITMDashboard from './views/itm/ITMDashboard.vue';
import ITMCustomers from './views/itm/ITMCustomers.vue';
import ITMSearch from './views/itm/ITMSearch.vue';
import ITMFedexSearch from './views/itm/ITMFedexSearch.vue';
import ITMCustomerAccess from './views/itm/ITMCustomerAccess.vue';
import ITMCustomerAccessLogIn from './views/itm/ITMCustomerAccessLogIn.vue';
import ITMCustomerAccessCreatePassword from './views/itm/ITMCustomerAccessCreatePassword.vue';
import ITMCustomerAccessNotFound from './views/itm/ITMCustomerAccessNotFound.vue';
import ITMNotification from './views/itm/ITMNotification.vue';
import CohortThoughtspot from './views/thoughtspot/CohortThoughtspot.vue';
import CohortThoughtspotSage from './views/thoughtspot/CohortThoughtspotSage.vue';

export const routes = [
  {
    path: '/SPCore/BrandSummary',
    name: 'spcoreBrandSummary',
    component: SPCoreBrandSummary,
  },
  {
    path: '/SPCore/FrmSummary',
    name: 'spcoreFrmSummary',
    component: SPCoreFrmSummary,
  },
  {
    path: '/SPCore/PatientSummary',
    name: 'spcorePatientSummary',
    component: SPCorePatientSummary,
  },
  {
    path: '/SPCore/PatientList',
    name: 'spcorePatientList',
    component: SPCorePatientList,
  },
  {
    path: '/SPCore/PatientList/:id',
    name: 'spcorePatient',
    component: SPCorePatient,
  },
  {
    path: '/SPCore/ProviderList',
    name: 'spcoreProviderList',
    component: SPCoreProviderList,
  },
  {
    path: '/SPCore/ProviderList/:id',
    name: 'spcoreProvider',
    component: SPCoreProvider,
  },
  {
    path: '/SPCore/ProductMovement',
    name: 'spcoreProductMovement',
    component: SPCoreProductMovement,
  },
  {
    path: '/SPCore/PharmacyNetwork',
    name: 'spcorePharmacyNetwork',
    component: SPCorePharmacyNetwork,
  },
  {
    path: '/SPCore/DataEnablement',
    name: 'spcoreDataEnablement',
    component: SPCoreDataEnablement,
  },
  {
    path: '/Scipher/RequestDemo',
    name: 'scipherRequestDemo',
    component: ScipherRequestDemo,
  },
  {
    path: '/SPCore/RequestDemo',
    name: 'spcoreRequestDemo',
    component: SPCoreRequestDemo,
  },
  {
    path: '/Analytics/Cohorts',
    name: 'cohorts',
    component: Cohorts,
    meta: { searchFilter: { text: null, search: [], filter: {}, special: null } },
  },
  {
    path: '/Analytics/Cohorts/Pinned',
    name: 'cohortsPinned',
    component: Cohorts,
    meta: { searchFilter: { text: null, search: [], filter: {}, special: { pinned: true } } },
  },
  {
    path: '/Analytics/Cohorts/Mine',
    name: 'cohortsMyCohorts',
    component: Cohorts,
    meta: { searchFilter: { text: null, search: [], filter: {}, special: { myCohorts: true } } },
  },
  {
    path: '/Analytics/Cohorts/ForVerifications',
    name: 'cohortsForVerifications',
    component: Cohorts,
    meta: { searchFilter: { text: null, search: [], filter: {}, special: { forVerifications: true } } },
  },
  {
    path: '/Analytics/Cohorts/:cohortId/Thoughtspot',
    name: 'CohortThoughtspot',
    component: CohortThoughtspot,
    props: true,
  },
  {
    path: '/Analytics/Cohorts/:cohortId/ThoughtspotSage',
    name: 'CohortThoughtspotSage',
    component: CohortThoughtspotSage,
    props: true,
  },
  {
    path: '/Analytics/Cohorts/:id/:tab',
    name: 'cohortTab',
    component: Cohort,
  },
  {
    path: '/Analytics/Cohorts/:id',
    name: 'cohort',
    component: Cohort,
  },
  {
    path: '/Analytics/CohortAnalyticRun/:id/DownloadResults',
    name: 'downloadResults',
    component: DownloadResults,
  },
  {
    path: '/MedInsights',
    name: 'medInsights',
    component: MedInsights,
  },
  {
    path: '/MedInsights/:group/:sheet',
    name: 'medInsightsGroupSheet',
    component: MedInsights,
  },
  {
    path: '/EnterpriseMetrics',
    name: 'enterpriseMetrics',
    component: EnterpriseMetrics,
  },
  {
    path: '/EnterpriseMetrics/:group/:sheet',
    name: 'enterpriseMetricsGroupSheet',
    component: EnterpriseMetrics,
  },
  {
    path: '/ITOperations',
    name: 'itOperations',
    component: ITOperations,
  },
  {
    path: '/ITOperations/:group/:sheet',
    name: 'itOperationsGroupSheet',
    component: ITOperations,
  },
  {
    path: '/HCPProfiles/:cohortId/:runId/:npi',
    name: 'hcpProfile',
    component: HCPProfiles,
  },
  {
    path: '/HCPProfiles/:cohortId/:runId/:npi/:tab',
    name: 'hcpProfileTab',
    component: HCPProfiles,
  },
  {
    path: '/AggregatedMediaDashboard/Brand',
    name: 'aggBrandDashboard',
    component: BrandDashboard,
  },
  {
    path: '/CallPlanning/:brandId/User',
    name: 'callPlanningUser',
    component: CallPlanningUser,
  },
  {
    path: '/CallPlanning/:brandId/Manager',
    name: 'callPlanningManager',
    component: CallPlanningManager,
  },
  {
    path: '/CallPlanning/:brandId/Manager/Users',
    name: 'callPlanningManagerUsers',
    component: CallPlanningManagerUsers,
  },
  {
    path: '/CallPlanning/:brandId/Manager/Users/:userId',
    name: 'callPlanningManagerUser',
    component: CallPlanningUser,
  },
  {
    path: '/CallPlanning/:brandId/Admin',
    name: 'callPlanningAdmin',
    component: CallPlanningAdmin,
  },
  {
    path: '/CallPlanning/:brandId/Admin/User/:userId',
    name: 'callPlanningAdminUser',
    component: CallPlanningAdminUser,
  },
  {
    path: '/CallPlanning',
    name: 'callPlanning',
    component: CallPlanning,
  },
  {
    path: '/Manage/AllApplicationUsers',
    name: 'allApplicationUsers',
    component: AllApplicationUsers,
  },
  {
    path: '/SQLGenerator/Show',
    name: 'sqlGenerator',
    component: SQLGenerator,
  },
  {
    path: '/ITM/Orders',
    name: 'itmOrders',
    component: ITMOrders,
  },
  {
    path: '/ITM/Products',
    name: 'itmProducts',
    component: ITMProducts,
  },
  {
    path: '/ITM/Dashboard',
    name: 'itmDashboard',
    component: ITMDashboard,
  },
  {
    path: '/ITM/Customers',
    name: 'itmCustomers',
    component: ITMCustomers,
  },
  {
    path: '/ITM/Search',
    name: 'itmSearch',
    component: ITMSearch,
  },
  {
    path: '/ITM/FedexSearch',
    name: 'itmFedexSearch',
    component: ITMFedexSearch,
  },
  {
    path: '/ITM/CustomerAccess/NotFound',
    name: 'itmCustomerAccessNotFound',
    component: ITMCustomerAccessNotFound,
    meta: { noAuth: true },
  },
  {
    path: '/ITM/CustomerAccess/:token/LogIn',
    name: 'itmCustomerAccessLogIn',
    component: ITMCustomerAccessLogIn,
    meta: { noAuth: true },
  },
  {
    path: '/ITM/CustomerAccess/:token/CreatePassword',
    name: 'itmCustomerAccessCreatePassword',
    component: ITMCustomerAccessCreatePassword,
    meta: { noAuth: true },
  },
  {
    path: '/ITM/CustomerAccess/:token',
    name: 'itmCustomerAccess',
    component: ITMCustomerAccess,
    meta: { noAuth: true },
  },
  {
    path: '/ITM/Notification',
    name: 'itmNotification',
    component: ITMNotification,
  },
  // {
  //   path: '/Actics',
  //   name: 'acticsLandingPage',
  //   component: ActicsLandingPage,
  // },
  // {
  //   // will match everything
  //   path: '*',
  //   component: Rates
  // }
];

var router = new Router({
  base: process.env.VUE_APP_ROUTE_URL,
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

const push = router.push;
router.push = function () {
  const path = arguments[0].path || arguments[0];
  const routeName = arguments[0].name || (router.match(path).matched || [])[0]?.name;
  if (routeName)
    return push.apply(this, arguments);
  else {
    store.state.isAppLoading = true;
    window.open(path, '_self');
  }
}

export default router;